import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DataCollectionMilestone } from '../../models/milestones/data-collection-milestone.model';
import { MilestoneService } from '../../services/milestone.service';
import { CurrentSiteService } from '../../services/current-site.service';
import { DataCollection } from '../../models/site-content/data-collection.model';
import { DisplayTimeAndHoursOffset } from '../../models/misc-metadata/display-time-and-hours-offset.model';
//import { SiteMilestonesSummary } from '../../models/milestones/site-milestones-summary.model';

// Export a dialogue data class.
export class SiteMilestoneDialogData {
    public milestone: DataCollectionMilestone;
    public availableMilestoneNames: string[] = null;
    public schedulerAvailable: boolean = false;

    public constructor(milestoneParam: DataCollectionMilestone, availableMilestoneNamesParam: string[], schedulerAvailableParam: boolean = false) {
        this.milestone = milestoneParam;
        this.availableMilestoneNames = availableMilestoneNamesParam;
        this.schedulerAvailable = schedulerAvailableParam;
    }
};

@Component({
    selector: 'app-site-milestone',
    templateUrl: './site-milestone.dialog.html',
    styleUrls: ['./site-milestone.dialog.scss'],
    standalone: false
})
export class SiteMilestoneDialog implements OnInit {
    // Properties.
    private milestone: DataCollectionMilestone = null;
    private targetDisplayTimes: DisplayTimeAndHoursOffset[] = null;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<SiteMilestoneDialog>,
        @Inject(MAT_DIALOG_DATA) public inputData: SiteMilestoneDialogData,//milestoneToModify: DataCollectionMilestone,
        private milestoneService: MilestoneService,
        private currentSiteService: CurrentSiteService) {
        this.milestone = inputData.milestone; //this.milestoneToModify;
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Get display times.
        //this.getDisplayTimes();
        return;
    }

    // Accessor methods used by my HTML code.
    public get Site(): DataCollection {
        return this.currentSiteService.Site;
    }

    public get Milestone(): DataCollectionMilestone {
        return this.milestone;
    }

    public get DialogueTitle(): string {
        return (this.creatingNewMilestone ? 'Create Site Milestone' : 'Update Site Milestone');
    }
    public get SaveButtonTitle(): string {
        return (this.creatingNewMilestone ? 'Create' : 'Update');
    }

    public get TargetDisplayTimes(): DisplayTimeAndHoursOffset[] {
        return this.targetDisplayTimes;
    }

    public get SchedulerAvailable(): boolean {
        return this.inputData.schedulerAvailable;
    }
    public get SchedulerAvailableMessage(): string {
        return (this.inputData.schedulerAvailable ? '' : 'Note:  scheduling not configured in this environment');
    }

    public get AvailableMilestoneNames(): string[] {
        return this.inputData.availableMilestoneNames;
    }

    public get SaveDisabled(): boolean {
        return (this.milestone == null);
    }

    // Control event handlers.
    public milestoneChanged(milestoneParam: DataCollectionMilestone): void {
        this.milestone = milestoneParam;
    }

    public save(): void {
        // Save the milestone.
        if (this.creatingNewMilestone) {
            this.milestoneService.createSiteMilestone(this.milestone).then(createdMilestone => {
                this.dialogRef.close(createdMilestone);
            });
        } else {
            this.milestoneService.updateSiteMilestone(this.milestone).then(updatedMilestone => {
                this.dialogRef.close(updatedMilestone);
            });
        }
    }

    public cancel(): void {
        this.dialogRef.close(null);
    }

    // Private helper methods.
    private get creatingNewMilestone(): boolean {
        return ((this.milestone.id == null) || (this.milestone.id <= 0));
    }
}
